<template>
    <div class="col-md-12 ml-auto mr-auto" v-if="isValid('CanViewOrderDetail') " v-bind:style="$i18n.locale == 'ar' ? languageChange('en') : languageChange('ar')">
        <div class="card" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'arabicLanguage'">
            <div class="card-body">
                <div class="col-lg-12">
                    <div class="tab-content" id="nav-tabContent">
                        <div class="card-header">
                            <div class="row">
                                <div class="col-lg-6" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'arabicLanguage'">
                                    <h5>{{ $t('PurchaseOrderView.PurchaseOrder') }} - {{purchase.registrationNo}}</h5>
                                </div>
                                <div class="col-lg-6" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'arabicLanguage' : 'text-left'">
                                    <span>
                                        {{purchase.date}}
                                    </span>
                                    <div v-if="isValid('CanViewPreviousVersion') && (purchase.approvalStatus === 5 || purchase.approvalStatus === 3)">
                                        <span v-for="(version,index) in purchase.purchaseOrderVersion" :key="index">
                                            <a href="javascript:void(0)" v-if="index!=0" title="View" class="btn  btn-primary btn-sm">{{version.version}}</a>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="card-body">
                            <div class="row">
                                <div class="col-lg-6">
                                    {{ $t('PurchaseOrderView.Supplier') }}
                                </div>
                                <div class="col-lg-6" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-right' : 'text-left'">
                                    {{ purchase.supplierName }}
                                </div>

                                <div class="col-lg-6">
                                    {{ $t('PurchaseOrderView.SupplierQuotationNumber') }}
                                </div>
                                <div class="col-lg-6" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-right' : 'text-left'">
                                    {{ purchase.invoiceNo }}
                                </div>

                                <div class="col-lg-6">
                                    {{ $t('PurchaseOrderView.QuotationDate') }}
                                </div>
                                <div class="col-lg-6" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-right' : 'text-left'">
                                    {{ purchase.invoiceDate }}
                                </div>

                                <div class="col-lg-6">
                                    {{ $t('PurchaseOrderView.TaxMethod') }}
                                </div>
                                <div class="col-lg-6" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-right' : 'text-left'">
                                    {{purchase.taxMethod}}
                                </div>

                                <div class="col-lg-6">
                                    {{ $t('PurchaseOrderView.VAT%') }}
                                </div>
                                <div class="col-lg-6" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-right' : 'text-left'">
                                    {{purchase.taxRatesName}}
                                </div>
                            </div>
                        </div>
                        <br />
                        <purchase-view-item @input="SavePurchaseItems" ref="childComponentRef" :taxMethod="purchase.taxMethod" :taxRateId="purchase.taxRateId" :raw="purchase.isRaw" :isSerial="true" :key="rander" :po="true" />
                        <div class="col-sm-8" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'arabicLanguage'">
                            <label>{{ $t('PurchaseOrderView.TermandCondition') }}:</label>
                            <br>
                            {{purchase.note}}
                        </div>
                        <div class="accordion" role="tablist" v-if="(purchase.approvalStatus === 3 || purchase.approvalStatus === 5 || purchase.approvalStatus === 9) && purchase.id != '00000000-0000-0000-0000-000000000000' && internationalPurchase=='true'">
                            <b-card no-body class="mb-1" v-if="isValid('CanUploadAttachment') || isValid('CanDownloadAttachment')">
                                <b-card-header header-tag="header" class="p-1" role="tab">
                                    <b-button block v-b-toggle.accordion-1 variant="primary">{{ $t('PurchaseOrderView.Attachment') }}</b-button>
                                </b-card-header>
                                <b-collapse id="accordion-1" accordion="my-accordion" role="tabpanel">
                                    <b-card-body>
                                        <import-attachment :purchase="purchase" :show="attachments" v-if="attachments" @close="attachmentSave" :document="'Purchase'" />
                                        <div>
                                            <div class="row" v-if="!purchase.isClose && internationalPurchase=='true' && (purchase.approvalStatus === 5 || purchase.approvalStatus === 3) && purchase.id != '00000000-0000-0000-0000-000000000000' && isValid('CanUploadAttachment')">
                                                <div class="col-md-12 text-right">
                                                    <a href="javascript:void(0)" class="btn btn-outline-primary " v-on:click="attachments=true"> Upload</a>
                                                </div>
                                            </div>
                                            <div class=" table-responsive">
                                                <table class="table ">
                                                    <thead class="m-0">
                                                        <tr>
                                                            <th>#</th>
                                                            <th>{{ $t('PurchaseOrderView.Date') }} </th>
                                                            <th>{{ $t('PurchaseOrderView.Description') }} </th>
                                                            <th v-if="isValid('CanDownloadAttachment')">{{ $t('PurchaseOrderView.Attachment') }}</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr v-for="(contact,index) in purchase.purchaseAttachments" v-bind:key="index">
                                                            <td>
                                                                {{index+1}}
                                                            </td>
                                                            <th>{{getDate(contact.date)}}</th>
                                                            <th>{{contact.description}}</th>

                                                            <td v-if="isValid('CanDownloadAttachment')">
                                                                <button class="btn btn-primary  btn-icon mr-2"
                                                                        v-if="contact.path != ''"
                                                                        v-on:click="DownloadAttachment(contact.path)">
                                                                    <i class="fa fa-download"></i>
                                                                </button>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </b-card-body>
                                </b-collapse>
                            </b-card>
                            <b-card no-body class="mb-1" v-if="isValid('CanAddOrderAction') || isValid('CanViewOrderAction')">
                                <b-card-header header-tag="header" class="p-1" role="tab">
                                    <b-button block v-b-toggle.accordion-2 variant="primary">Actions</b-button>
                                </b-card-header>
                                <b-collapse id="accordion-2" accordion="my-accordion" role="tabpanel">
                                    <b-card-body>
                                        <add-company-action :action="action" :show="show" v-if="show" @close="IsSave" :document="'Purchase'" />

                                        <div class="row">
                                            <div class="col-md-12" v-if="!purchase.isClose && internationalPurchase=='true' && (purchase.approvalStatus === 5 || purchase.approvalStatus === 3|| purchase.approvalStatus === 3) && purchase.id != '00000000-0000-0000-0000-000000000000' && isValid('CanAddOrderAction')">
                                                <div class="col-sm-6 float-right">
                                                    <a href="javascript:void(0)" class="btn btn-outline-primary  float-right" v-on:click="show=true"> Action</a>
                                                </div>
                                            </div>
                                            <div class=" table-responsive" v-if="isValid('CanViewOrderAction')">
                                                <table class="table ">
                                                    <thead class="m-0">
                                                        <tr>
                                                            <th>#</th>
                                                            <th>Status</th>
                                                            <th>{{ $t('PurchaseOrderView.Date') }} </th>
                                                            <th>Description/Reason</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr v-for="(process,index) in purchase.actionProcess" v-bind:key="process.id">
                                                            <td>
                                                                {{index+1}}
                                                            </td>
                                                            <th><span class="badge badge-primary">{{process.processName}}</span></th>
                                                            <th>{{getDate(process.date)}}</th>
                                                            <th>{{process.description}}</th>

                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </b-card-body>
                                </b-collapse>
                            </b-card>
                            <b-card no-body class="mb-1" v-if="isValid('CanAddAdvancePayment') || isValid('CanViewAdvancePayment') || isValid('CanViewDetailAdvancePayment')">
                                <b-card-header header-tag="header" class="p-1" role="tab">
                                    <b-button block v-b-toggle.accordion-3 variant="primary">Payment</b-button>
                                </b-card-header>
                                <b-collapse id="accordion-3" accordion="my-accordion" role="tabpanel">
                                    <b-card-body>
                                        <purchaseorder-payment :totalAmount="totalAmount" :customerAccountId="advanceAccountId" :show="payment" v-if="payment" @close="paymentSave" :isSaleOrder="'false'" :isPurchase="'true'" :purchaseOrderId="purchase.id" :formName="'AdvancePay'" />
                                        <div>
                                            <div class="row" v-if="!purchase.isClose && internationalPurchase=='true' && (purchase.approvalStatus === 5 || purchase.approvalStatus === 3) && purchase.id != '00000000-0000-0000-0000-000000000000' && isValid('CanAddAdvancePayment')">
                                                <div class="col-md-12 text-right">
                                                    <a href="javascript:void(0)" class="btn btn-outline-primary " v-on:click="payment=true"> Add Payment</a>
                                                </div>
                                            </div>
                                            <div class=" table-responsive" v-if="isValid('CanViewAdvancePayment')">
                                                <table class="table ">
                                                    <thead class="m-0">
                                                        <tr>
                                                            <th>#</th>
                                                            <th style="width:20%;">{{ $t('PurchaseOrderView.Date') }} </th>
                                                            <th style="width:20%;">{{ $t('PurchaseOrderView.VoucherNumber') }} </th>
                                                            <th class="text-right">{{ $t('PurchaseOrderView.Amount') }} </th>
                                                            <th class="text-center">{{ $t('PurchaseOrderView.PaymentMode') }} </th>
                                                            <th></th>
                                                            <th>{{ $t('PurchaseOrderView.Description') }} </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr v-for="(payment,index) in purchase.paymentVoucher" v-bind:key="index">
                                                            <td>
                                                                {{index+1}}
                                                            </td>
                                                            <th>{{getDate(payment.date)}}</th>
                                                            <th>{{payment.voucherNumber}}</th>
                                                            <th class="text-right">{{currency}} {{parseFloat(payment.amount).toFixed(3).slice(0,-1).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,")}}</th>
                                                            <th class="text-center"><span v-if="payment.paymentMode==0">Cash</span><span v-if="payment.paymentMode==1">Bank</span></th>
                                                            <th>{{payment.narration}}</th>
                                                            <th>
                                                                <a href="javascript:void(0)" title="Payment View" class="btn  btn-icon btn-primary btn-sm" v-on:click="ViewPaymentVoucher(payment.id, false)" v-if="isValid('CanViewDetailAdvancePayment')"><i class=" fas fa-eye"></i></a>
                                                            </th>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </b-card-body>
                                </b-collapse>
                            </b-card>
                            <b-card no-body class="mb-1" v-if="isValid('CanViewOrderExpense') || isValid('CanAddOrderExpense') || isValid('CanViewDetailOrderExpense')">
                                <b-card-header header-tag="header" class="p-1" role="tab">
                                    <b-button block v-b-toggle.accordion-4 variant="primary">Expense</b-button>
                                </b-card-header>
                                <b-collapse id="accordion-4" accordion="my-accordion" role="tabpanel">
                                    <b-card-body>
                                        <purchaseorder-expense :show="expense" v-if="expense" @close="expenseSave" :isPurchase="'true'" :purchaseOrderId="purchase.id" :formName="'AdvanceExpense'" />
                                        <purchaseorder-expensebill :show="bill" v-if="bill" @close="expenseSave" :isInvoice="false" :purchaseId="purchase.id" />
                                        <div>
                                            <div class="row" v-if="(purchase.approvalStatus === 5 || purchase.approvalStatus === 3) && !purchase.isClose && purchase.id != '00000000-0000-0000-0000-000000000000' && isValid('CanAddOrderExpense')">
                                                <div class="col-md-12 text-right">
                                                    <a href="javascript:void(0)" class="btn btn-outline-primary " v-on:click="bill=true"> Add Bill</a>
                                                    <a href="javascript:void(0)" class="btn btn-outline-primary " v-on:click="expense=true"> Add Expense</a>
                                                </div>
                                            </div>
                                            <div class=" table-responsive" v-if="isValid('CanViewOrderExpense')">
                                                <table class="table ">
                                                    <thead class="m-0">
                                                        <tr>
                                                            <th>#</th>
                                                            <th style="width:20%;">{{ $t('PurchaseOrderView.Date') }} </th>
                                                            <th style="width:20%;">{{ $t('PurchaseOrderView.VoucherNumber') }} </th>
                                                            <th class="text-right">{{ $t('PurchaseOrderView.Amount') }} </th>
                                                            <th class="text-right">Used Amount </th>
                                                            <th class="text-center">{{ $t('PurchaseOrderView.PaymentMode') }} </th>
                                                            <th>{{ $t('PurchaseOrderView.Description') }} </th>
                                                            <th></th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr v-for="(payment,index) in purchase.purchaseOrderExpenses" v-bind:key="index">
                                                            <td>
                                                                {{index+1}}
                                                            </td>
                                                            <th>{{getDate(payment.date)}}</th>
                                                            <th>{{payment.voucherNumber}}</th>
                                                            <th class="text-right">{{currency}} {{parseFloat(payment.amount).toFixed(3).slice(0,-1).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,")}}</th>
                                                            <th class="text-right">{{currency}} {{parseFloat(payment.usedAmount).toFixed(3).slice(0,-1).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,")}}</th>
                                                            <th class="text-center"><span v-if="payment.paymentMode==0">Cash</span><span v-if="payment.paymentMode==1">Bank</span></th>
                                                            <th>{{payment.narration}}</th>
                                                            <th>
                                                                <a href="javascript:void(0)" title="Payment View" class="btn  btn-icon btn-primary btn-sm" v-on:click="ViewPaymentVoucher(payment.id, true)" v-if="isValid('CanViewDetailOrderExpense')"><i class=" fas fa-eye"></i></a>
                                                            </th>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </b-card-body>
                                </b-collapse>
                            </b-card>

                        </div>

                    </div>

                    <div class="row">
                        <div class="col-md-6 ">
                            <button class="btn btn-primary mr-2" v-on:click="Attachment()">
                                {{ $t('PurchaseView.Attachment') }}
                            </button>
                        </div>
                        <div class="col-md-6" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-right' : 'text-left'">
                            <button class="btn btn-danger  mr-2"
                                    v-on:click="goToPurchase">
                                {{ $t('PurchaseOrderView.Cancel') }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <bulk-attachment :documentid="purchase.id" :show="isAttachshow" v-if="isAttachshow" @close="attachmentSaved" />
        <purchase-order-payment-view :data="paymentview" :formName="'AdvancePay'" @close="paymentView" :show="isPaymentview" v-if="isPaymentview" />
        <purchase-order-payment-view :data="paymentview" :formName="'AdvanceExpense'" @close="paymentView" :show="isExpenseview" v-if="isExpenseview" />
    </div>
    <div v-else> <acessdenied></acessdenied></div>

</template>
<script>
    import clickMixin from '@/Mixins/clickMixin'
    import moment from "moment";
    import "vue-loading-overlay/dist/vue-loading.css";
    import { required } from "vuelidate/lib/validators";
    export default {
        mixins: [clickMixin],
        data: function () {
            return {
                //versionAllow: '',
                internationalPurchase: '',
                currency: '',
                daterander: 0,
                rander: 0,
                totalAmount: 0,
                isAttachshow: false,
                bill: false,
                attachment: false,
                attachments: false,
                show: false,
                payment: false,
                expense: false,
                purchase: {
                    id: "00000000-0000-0000-0000-000000000000",
                    date: "",
                    registrationNo: "",
                    supplierId: "",
                    invoiceNo: "",
                    invoiceDate: "",
                    purchaseOrder: "",
                    note: '',
                    purchaseOrderItems: [],
                    path: '',
                    isRaw: false,
                },
                raw: '',
                loading: false,
                language: 'Nothing',
                options: [],
                supplierRender: 0,
                advanceAccountId: '',
                paymentview: '',
                isPaymentview: false,
                isExpenseview: false,
                action: {
                    id: '00000000-0000-0000-0000-000000000000',
                    purchaseOrderId: '',
                    processId: '',
                    date: '',
                    description: '',
                },
            };
        },
        validations: {
            purchase: {
                date: { required },
                registrationNo: { required },
                supplierId: { required },
                invoiceNo: {},
                invoiceDate: {},

                purchaseOrderItems: { required },
            },
        },
        methods: {
            Attachment: function () {
                this.isAttachshow = true;
            },

            attachmentSaved: function () {
                this.isAttachshow = false;
            },

            getTotalAmount: function () {

                this.totalAmount = this.$refs.childComponentRef.getTotalAmount();
            },
            getDate: function (date) {
                if (date == null || date == undefined) {
                    return "";
                }
                else {
                    return moment(date).format('LLL');
                }
            },
            attachmentSave: function () {
                this.GetAttachment();
                this.GetProcessType();
                this.attachments = false;
            },
            IsSave: function () {
                this.show = false;
                this.GetProcessType();
            },
            paymentSave: function () {
                this.payment = false;
                this.GetPaymentVoucher();
                this.GetProcessType();
            },
            expenseSave: function () {
                this.expense = false;
                this.bill = false;
                this.GetExpenseVoucher();
                this.GetProcessType();
            },
            GetPaymentVoucher: function () {
                var root = this;
                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }

                root.$https.get('Purchase/PurchaseOrderPaymentList?id=' + this.purchase.id, { headers: { "Authorization": `Bearer ${token}` } })
                    .then(function (response) {
                        if (response.data != null && response.data != '') {
                            root.purchase.paymentVoucher = response.data;
                        }
                    });
            },
            GetExpenseVoucher: function () {
                var root = this;
                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }

                root.$https.get('Purchase/PurchaseOrderExpensePaymentList?id=' + this.purchase.id, { headers: { "Authorization": `Bearer ${token}` } })
                    .then(function (response) {
                        if (response.data != null && response.data != '') {
                            root.purchase.purchaseOrderExpenses = response.data;
                        }
                    });
            },
            GetAttachment: function () {
                var root = this;
                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }

                root.$https.get('Purchase/PurchaseOrderAttachmentList?id=' + this.purchase.id, { headers: { "Authorization": `Bearer ${token}` } })
                    .then(function (response) {
                        if (response.data != null && response.data != '') {
                            root.purchase.purchaseAttachments = response.data;
                        }
                    });
            },
            GetProcessType: function () {
                var root = this;
                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }

                root.$https.get('Purchase/PurchaseOrderActionList?id=' + this.purchase.id, { headers: { "Authorization": `Bearer ${token}` } })
                    .then(function (response) {
                        if (response.data != null && response.data != '') {
                            root.purchase.actionProcess = response.data;
                        }
                    });
            },
            ChangeSupplier: function () {
                this.supplierRender++;
            },
            languageChange: function (lan) {
                if (this.language == lan) {
                    if (this.purchase.id == '00000000-0000-0000-0000-000000000000') {

                        var getLocale = this.$i18n.locale;
                        this.language = getLocale;

                        this.$router.go('/addproduct');
                    }
                    else {
                        this.$swal({
                            title: 'Error!',
                            text: 'You cannot Change language during update, otherwise your current page data will be lose',
                            type: 'error',
                            confirmButtonClass: "btn btn-danger",
                            icon: 'error',
                            timer: 4000,
                            timerProgressBar: true,
                        });
                    }
                }


            },

            DownloadAttachment(path) {

                var root = this;
                var token = '';
                if (root.$session.exists()) {
                    token = localStorage.getItem('token');
                }
                var ext = path.split('.')[1];
                root.$https.get('/Contact/DownloadFile?filePath=' + path, { headers: { "Authorization": `Bearer ${token}` }, responseType: 'blob' })
                    .then(function (response) {
                        const url = window.URL.createObjectURL(new Blob([response.data]));
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', 'file.' + ext);
                        document.body.appendChild(link);
                        link.click();
                    });
            },

            uploadImage() {

                var root = this;
                var token = '';
                if (root.$session.exists()) {
                    token = localStorage.getItem('token');
                }

                var file = null;

                file = this.$refs.imgupload1.files;

                var fileData = new FormData();
                for (var k = 0; k < file.length; k++) {
                    fileData.append("files", file[k]);
                }
                root.$https.post('/Company/UploadFilesAsync', fileData, { headers: { "Authorization": `Bearer ${token}` } })
                    .then(function (response) {
                        if (response.data != null) {

                            root.purchase.path = response.data;

                        }
                    },
                        function () {
                            this.loading = false;
                            root.$swal({
                                title: "Error!",
                                text: "Something went wrong",
                                type: 'error',
                                confirmButtonClass: "btn btn-danger",
                                buttonsStyling: false
                            });
                        });
            },

            AutoIncrementCode: function () {
                var root = this;
                var token = "";
                if (root.$session.exists()) {
                    token = localStorage.getItem("token");
                }
                root.$https
                    .get("/Purchase/PurchaseOrderAutoGenerateNo", {
                        headers: { Authorization: `Bearer ${token}` },
                    })
                    .then(function (response) {
                        if (response.data != null) {
                            root.purchase.registrationNo = response.data;
                        }
                    });
            },
            SavePurchaseItems: function (purchaseOrderItems) {
                this.purchase.purchaseOrderItems = purchaseOrderItems;
                this.getTotalAmount();
            },
            savePurchase: function (status) {
                this.purchase.approvalStatus = status
                this.loading = true;
                var root = this;
                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }
                this.$https
                    .post('/Purchase/SavePurchaseOrderInformation', root.purchase, { headers: { "Authorization": `Bearer ${token}` } })
                    .then(response => {
                        if (response.data.message.id != '00000000-0000-0000-0000-000000000000' && response.data.action == "Add") {
                            root.loading = false
                            root.info = response.data.bpi

                            root.$swal({
                                title: "Saved!",
                                text: response.data.message.isAddUpdate,
                                type: 'success',
                                confirmButtonClass: "btn btn-success",
                                buttonStyling: false,
                                icon: 'success',
                                timer: 1500,
                                timerProgressBar: true,

                            }).then(function (ok) {
                                if (ok != null) {
                                    root.$router.go('addpurchaseorder');
                                }
                            });
                        }
                        else if (response.data.message.id != '00000000-0000-0000-0000-000000000000' && response.data.action == "Update") {
                            root.loading = false
                            root.info = response.data.bpi

                            root.$swal({
                                title: "Saved!",
                                text: response.data.message.isAddUpdate,
                                type: 'success',
                                confirmButtonClass: "btn btn-success",
                                buttonStyling: false,
                                icon: 'success',
                                timer: 1500,
                                timerProgressBar: true,

                            }).then(function (ok) {
                                if (ok != null) {
                                    root.$router.push("purchaseorder");
                                }
                            });
                        }
                        else {
                            root.$swal({
                                title: 'Error!',
                                text: response.data.message.isAddUpdate,
                                type: 'error',
                                confirmButtonClass: "btn btn-danger",
                                icon: 'error',
                                timer: 1500,
                                timerProgressBar: true,
                            });
                        }
                    })
                    .catch(error => {
                        console.log(error)
                        root.$swal.fire(
                            {
                                icon: 'error',
                                title: 'Something Went Wrong!',
                                text: error,
                            });

                        root.loading = false
                    })
                    .finally(() => root.loading = false)

            },

            goToPurchase: function () {
                this.$router.push({
                    path: '/purchaseorder',
                    query: {
                        data: 'purchaseorders'
                    }
                })
            },
            ViewPaymentVoucher: function (id, expense) {
                var root = this;
                
                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }
                root.$https.get('/Purchase/PurchaseOrderPaymentDetail?Id=' + id + '&expense=' + expense, { headers: { "Authorization": `Bearer ${token}` } }).then(function (response) {
                    if (response.data != null) {
                        root.$https.get('/PaymentVoucher/PaymentVoucherDetails?Id=' + response.data.paymentVoucherId, { headers: { "Authorization": `Bearer ${token}` } }).then(function (response) {
                            if (response.data != null) {
                                root.paymentview = response.data;
                                if (expense) {
                                    root.isExpenseview = true;
                                }
                                else {
                                    root.isPaymentview = true;
                                }
                            }
                        });
                    }
                });
            },
            paymentView: function () {
                this.isPaymentview = false;
                this.isExpenseview = false;
            },

        },
        created: function () {
            if (this.$route.query.data != undefined) {

                this.purchase = this.$route.query.data;
                this.advanceAccountId = this.$route.query.data.advanceAccountId;
                this.purchase.date = moment(this.purchase.date).format("LLL");
                this.action.purchaseOrderId = this.purchase.id;
                this.attachment = true;
                this.rander++;
                this.rendered++;
            }
        },
        mounted: function () {
            this.language = this.$i18n.locale;
            this.currency = localStorage.getItem('currency');
            this.internationalPurchase = localStorage.getItem('InternationalPurchase');
            //this.versionAllow = localStorage.getItem('VersionAllow');
            if ((this.$i18n.locale == 'en' || this.isLeftToRight())) {
                this.options = ['Inclusive', 'Exclusive'];
            }
            else {
                this.options = ['شامل', 'غير شامل'];
            }
            if (this.$session.exists()) {
                this.raw = localStorage.getItem('IsProduction');
            }





        },
    };
</script>
